'use strict';
var populationsSum = 0;
var entries = 0;
document.querySelectorAll('.population').forEach(function(span) {
    var number = Number(span.textContent.replace(/,/g, ''));
    populationsSum += number;
    entries++;
});
var averagePopulation = Math.round(populationsSum / entries);
document.querySelector('.total-population').textContent = populationsSum.toLocaleString('en-US');
document.querySelector('.average-population').textContent = averagePopulation.toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.cb87ba41.js.map
